import api from "../config";
const path = "datenstand"

export default {
  get: () => {
    return api.get(path)
  }
}
